(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["modal_promo"]) return;
  try {
    
$('body').on('click', '.small_promo_modal, h2, .promo_modal_arrow', function(e){
  var $bottom_modal = $('.bottom_modal');
  $bottom_modal.toggleClass('opened');
});

  } catch(e) { console.error(e); }
})();

})();
